import {LOCATION_PROPS} from "@/redux/rtk/admin/locations/types";
import {createSelector, createSlice} from "@reduxjs/toolkit";
import {TEMPLATE_PROPS} from "@/app/admin/templates/page";
import {CYCLE_PROPS} from "@/app/admin/cycles/page";

const name = "SHARED";

interface INITIAL_STATE {
    location: LOCATION_PROPS | null,
    cycle: CYCLE_PROPS | null,
    template: TEMPLATE_PROPS | null,
    registrationName: string | null
}

const initialState: INITIAL_STATE = {
    location: null,
    cycle: null,
    template: null,
    registrationName: null
}

const sharedSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        updateLocationDetails: (state, {payload}: { payload: LOCATION_PROPS }) => {
            state.location = payload;
        },
        updateCycleDetails: (state, {payload}: { payload: CYCLE_PROPS }) => {
            state.cycle = payload;
        },
        updateTemplateDetails: (state, {payload}: { payload: TEMPLATE_PROPS }) => {
            state.template = payload;
        },
        updateRegistrationName: (state, {payload}: { payload: string }) => {
            state.registrationName = payload;
        }
    },
    extraReducers: (builder) => {

    }
});

export const sharedSelectors = {
    getLocationDetails: createSelector(
        (state) => {
            return state.shared.location;
        },
        (location) => location,
    ),
    getCycleDetails: createSelector(
        (state) => {
            return state.shared.cycle;
        },
        (cycle) => cycle,
    ),
    getTemplateDetails: createSelector(
        (state) => {
            return state.shared.template;
        },
        (template) => template,
    ),
    getRegistrationName: createSelector(
        (state) => {
            return state.shared.registrationName;
        },
        (registrationName) => registrationName,
    )
}

const {reducer, actions} = sharedSlice;
export const {updateRegistrationName, updateLocationDetails, updateCycleDetails, updateTemplateDetails} = actions;
export default reducer;